<template>
  <div class="global-tab">
    <el-tabs v-model="currentPath" type="card" @tab-change="to" @tab-remove="close">
      <el-tab-pane
          v-for="item in tabs"
          :key="item.id"
          :name="item.id"
          :closable="item?.closable || item?.closable == false ? item?.closable : true"
      >
        <template #label>
          <span class="dot"></span>
          {{item.title}}
        </template>
      </el-tab-pane>
    </el-tabs>
    <el-dropdown class="global-tab-dropdown">
      <el-icon>
        <ArrowDown/>
      </el-icon>
      <template #dropdown>
        <el-dropdown-menu class="global-tab-dropdown-menu">
          <el-dropdown-item @click="refresh">刷新当前</el-dropdown-item>
          <el-dropdown-item @click="closeAll">关闭全部</el-dropdown-item>
          <el-dropdown-item @click="closeOther">关闭其他</el-dropdown-item>
          <el-dropdown-item @click="closeCurrent">关闭当前</el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
  </div>
</template>

<script>
export default {
  name: "GlobalTab"
}
</script>
<script setup>
import {useTab} from "@/layouts/composable/useTab";
import {useUserStore} from "@/store/module/user";

const userStore = useUserStore()
const {tabs, to, close, closeAll, closeOther, closeCurrent, currentPath} = useTab()

const refresh = () => {
  userStore.routerAlive = false
  setTimeout(function () {
    userStore.routerAlive = true
  }, 500)
}
</script>

<style scoped>
.global-tab {
  display: flex;
  position: relative;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  border-top: 1px solid var(--el-bg-color-page);
  z-index: 999;
}

.global-tab .el-tabs {
  flex-grow: 1;
  width: calc(100% - 40px);
  background-color: var(--el-bg-color);
}
.global-tab > .el-dropdown > i {
  width: 40px;
  background: var(--el-bg-color);
  height: 100%;
  line-height: 40px;
  text-align: center;
  border-left: 1px solid var(--el-bg-color-page);
}
.dot {
  display: inline-block;
  background-color: var(--el-bg-color-page);
  margin-right: 8px;
  border-radius: 50px;
  height: 8px;
  width: 8px;
}
:deep(.el-tabs--card > .el-tabs__header .el-tabs__nav){
  border: none;
}
:deep(.el-tabs--card > .el-tabs__header .el-tabs__item.is-active .dot){
  background-color: var(--el-color-primary);
}
</style>
